import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import MDButton from "components/MDButton";
import React from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { setLayout } from "../../../redux/slices/materialUISlice";
import { useDispatch, useSelector } from "react-redux";

// Images
import { Box, IconButton, InputAdornment, Stack, TextField, Typography } from "@mui/material";
import { loginUser } from "../../../redux/slices/authSlice";
import { openSnackbar } from "../../../redux/slices/common";
import hyperwolfLogo from "assets/images/hyperwolf.svg";
import authImg from "assets/images/auth-bg.jpg";
import colors from "assets/theme/base/colors";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { requestPermission } from "firebaseInit";
import { getData } from "utilities/common";
import { HYPERWOLF } from "utilities/constants";
import { HYPERDRIVE } from "utilities/constants";
import { setData } from "utilities/common";
import { setAdminsMode } from "../../../redux/slices/common";

function Basic() {
  const navigate = useNavigate()
  const { logging = false } = useSelector(state => state.auth)
  const dispatch = useDispatch();
  const [userData, setUserData] = useState({})

  const handleLogin = async () => {
    dispatch(loginUser({ ...userData,userType:"admin", deviceToken: JSON.parse(getData('firebaseDeviceToken')) })).unwrap().then((res) => {
         const userPermissions = res?.permissions

      let permissionsArray = [];
      let adminMode = null;
      
      if (Array.isArray(userPermissions.hempPermissions) && userPermissions.hempPermissions.length !== 0) {
        adminMode = 'hemp';
        permissionsArray = userPermissions.hempPermissions;
      } else if (Array.isArray(userPermissions.stiloPermissions) && userPermissions.stiloPermissions.length !== 0) {
        adminMode = 'stilo';
        permissionsArray = userPermissions.stiloPermissions;
      } else if (Array.isArray(userPermissions.hwPermissions) && userPermissions.hwPermissions.length !== 0) {
        adminMode = 'hyperwolf';
        permissionsArray = userPermissions.hwPermissions;
      }
      else if (Array.isArray(userPermissions.hyperdrivePermissions) && userPermissions.hyperdrivePermissions.length !== 0) {
        adminMode = 'hyperwolf';
        permissionsArray = userPermissions.hyperdrivePermissions;
      }

      // Set adminsMode in localStorage and Redux before navigation
      if (adminMode) {
        setData('adminsMode', adminMode);
        dispatch(setAdminsMode(adminMode));
      }

      let screenToLoad = '/';

      if (permissionsArray.length > 0) {
        // First, check for Dashboard
        const dashboardScreen = permissionsArray.find(
          s => s.title && String(s.title).toLowerCase().trim() === 'dashboard'
        );
        if (dashboardScreen?.redirectUrl) {
          screenToLoad = dashboardScreen.redirectUrl;
        } else {
          // Fallback to first permission with redirectUrl
          const firstWithRedirect = permissionsArray.find(
            obj => obj && typeof obj.redirectUrl === 'string' && obj.redirectUrl.trim() !== ''
          );
          if (firstWithRedirect && firstWithRedirect.redirectUrl) {
            screenToLoad = firstWithRedirect.redirectUrl;
          } else if (permissionsArray[0]?.redirectUrl) {
            screenToLoad = permissionsArray[0].redirectUrl;
          }
        }
      }

      // Navigate after localStorage is set - no reload needed
      showError(res?.message, 'success')
      // Use setTimeout to ensure localStorage is written before navigation
      setTimeout(() => {
        navigate(screenToLoad, { replace: true });
      }, 0);
    }).catch((err) => {
      showError(err?.message, 'error')
    })
  };

  const showError = (message, errortype) => {
    if (errortype === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }))
    }
    if (errortype === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }))
    }
  }

  const onChangeHandler = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value })
  }
  const { pathname } = useLocation();

  useEffect(() => {
    dispatch(setLayout("singup"))
  }, [pathname]);

  const { primary } = colors;


  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    requestPermission()
  }, [])

  return (
    <Grid className="auth-pg" alignItems="center" container>
      <Grid item xs={12} md={6} p={2.5} pt={{ xs: 8, md: 2.5 }}>
        <Stack textAlign="center" direction="column" alignItems="center" justifyContent="center" maxWidth="500px" mx="auto" height="100%">
          <img src={hyperwolfLogo} alt="HYPERWOLF" height="32px" />

          <Box textAlign="center" mt={6} mb={4}>
            <Typography variant="h2" fontWeight="semibold">Sign In</Typography>
            <Typography variant="body1" mt={1}>Welcome! Please Sign In to continue.</Typography>
          </Box>

          <TextField fullWidth sx={{ mb: 3 }} label='Enter Email' onChange={onChangeHandler} name="email" />
          <TextField fullWidth label="Enter Password" onChange={onChangeHandler} type={showPassword ? 'text' : 'password'} name="password"
            InputProps={{
              endAdornment: (
                <InputAdornment position="center">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="center"
                  >
                    {!showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Box textAlign='end' width='100%'>
            <Typography mt={1} variant='h6' fontWeight="medium">
              <Link to="/forgot-password" style={{ color: primary.main }}>
                Forgot Password?
              </Link>
            </Typography>
          </Box>
          <MDButton onClick={handleLogin} sx={{ mt: 3, minWidth: "100%" }} disabled={logging} variant="contained" color="primary">Login</MDButton>
        </Stack>
      </Grid>

      <Grid item xs={12} md={6} p={2.5}>
        <img src={authImg} alt="HYPERWOLF" className="auth-banner-img" />
      </Grid>
    </Grid>
  );
}

export default Basic;
